<div class="chapter-pagination" *ngIf="(chapters$ | async)?.length > 1" appEventFence>
  <!-- Previous -->
  <button
    type="button"
    class="chapter-pagination__button chapter-pagination__button--back"
    [disabled]="chapterIndex === 0"
    (click)="handlePreviousClick()">
    <fa-icon size="lg" icon="angle-left"></fa-icon>
  </button>

  <!-- Count -->
  <span class="chapter-pagination__count">
    {{ chapterIndex + 1 }} / {{(chapters$ | async)?.length}}
  </span>

  <!-- Next -->
  <button 
    type="button"
    class="chapter-pagination__button chapter-pagination__button--next"
    [disabled]="chapterIndex === ((chapters$ | async)?.length - 1)"
    (click)="handleNextClick()">
    <fa-icon size="lg" icon="angle-right"></fa-icon>
  </button>
</div>